import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const NewApplicationsContainer = () => {
  const ApplStatus = "1";
  const Title = "New Application";
  const Desc = "Displays all newly submitted job applications awaiting initial screening and review. Recruiters can assess applicant profiles, verify submitted documents and qualifications, evaluate eligibility against job requirements, and initiate the recruitment process by advancing qualified candidates to the appropriate hiring stage.";
  return (
    <>
      <Breadcrumbs mainTitle="New Applications" parent="Application Forms" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <ApplicationTable 
                  ApplStatus={ApplStatus} 
                  Title={Title} 
                  Desc={Desc}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NewApplicationsContainer;
